module.exports = __webpack_public_path__ + "img/ophiuchus.806509b9.png";